/*------------------------------------*\
    REGIONS MAP
\*------------------------------------*/
class RegionsMap {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        let coordinators = document.querySelectorAll('.js-regions-map-coordinator');
        let mapRegions = document.querySelectorAll('.js-regions-map-region');

        Array.from(coordinators).forEach(item => {
            let region = item.getAttribute('data-region');
            let relatedMapRegion = self.elem.querySelector(`.js-regions-map-region[data-region="${ region }"]`);

            item.addEventListener('mouseover', evt => {
                relatedMapRegion.classList.add('is-active');
            });

            item.addEventListener('mouseout', evt => {
                relatedMapRegion.classList.remove('is-active');
            });
        });

        Array.from(mapRegions).forEach(item => {
            let region = item.getAttribute('data-region');
            let relatedCoordinator = self.elem.querySelector(`.js-regions-map-coordinator[data-region="${ region }"]`);

            item.addEventListener('mouseover', evt => {
                relatedCoordinator.classList.add('is-active');
            });

            item.addEventListener('mouseout', evt => {
                relatedCoordinator.classList.remove('is-active');
            });
        });
    }
}

export default RegionsMap;
